<template>
    <loader
        v-show="commonStore.loader"
        name="dots"
        object="#FF3C00"
        size="5"
        speed="2"
        bg="#343a40"
        objectbg="#999793"
        opacity="20"
        :disableScrolling="false"
    ></loader>
    <header-box-6 v-if="enabledStore.portalTypeBooks !== null"
    :bookPortal="enabledStore.portalTypeBooks"></header-box-6>
    <main>
        <div class="container">
            <router-view></router-view>
        </div>
    </main>
    <footer-box-4></footer-box-4>
</template>

<script>
import { useAuthStore, useCommonStore, useEnabledStore } from "@/stores";
import { RouterView } from "vue-router";
import HeaderBox6 from "./components/layouts/header/HeaderBox6.vue";
import FooterBox4 from "./components/layouts/footer/FooterBox4.vue";

export default {
    components: {
        RouterView,
        HeaderBox6,
        FooterBox4,
    },
    data() {
        return {
            commonStore: useCommonStore(),
            authStore: useAuthStore(),
            enabledStore: useEnabledStore(),
        };
    },
    methods: {
        checkPortalType() {
            this.enabledStore.checkPortalType();
        },
    },
    created() {
      this.checkPortalType();
    },
    computed: {
        isAuth() {
            return this.authStore.isAuth;
        },
        isPortalTypeBooks() {
        return this.enabledStore.isPortalTypeBooks;
      },
    },
};
</script>


